import { useDispatch, useSelector } from 'react-redux';
import { CaretLeftFilled } from '@ant-design/icons';
import { Button } from 'antd';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import ComponentSettings from '../../../baseComponents/ComponentSettings';
import PageSettings from '../../../baseComponents/PageSettings';
import { updateCanvasSize } from '../../../utils';
import { actions } from '../../../redux';

export default () => {
  const activeType = useSelector((state) => state.board.activeType);
  const dispatch = useDispatch();
  const { userSettings } = useSelector((state) => state.app);

  const onBtnClick = () => {
    dispatch(actions.setUserSettings({ isExpandMenuRight: !userSettings.isExpandMenuRight }));
  };

  useEffect(() => {
    updateCanvasSize(window.canvas);
  }, [userSettings.isExpandMenuRight]);
  return (
    <div className={classNames('right-side-wrapper', userSettings.isExpandMenuRight ? 'show-panel' : 'hide-panel')}>
      <Button
        style={{ background: '#fff' }}
        className="show-hide-button"
        type="text"
        size="small"
        shape="circle"
        icon={
          <CaretLeftFilled
            className={classNames(userSettings.isExpandMenuRight ? 'transform' : '')}
            style={{ fontSize: '16px', color: '#888', transition: 'all 0.3s, visibility 0s' }}
          />
        }
        onClick={onBtnClick}
      />
      <div style={{ opacity: userSettings.isExpandMenuRight ? 1 : 0, transition: 'all 0.2s, visibility 0s' }}>
        {activeType ? <ComponentSettings /> : <PageSettings />}
      </div>
    </div>
  );
};
